import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62d2e462&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d2e462",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62d2e462')) {
      api.createRecord('62d2e462', component.options)
    } else {
      api.reload('62d2e462', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62d2e462&scoped=true", function () {
      api.rerender('62d2e462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/batch/index.vue"
export default component.exports